document.addEventListener('DOMContentLoaded', () => {
  const productController = UD_VUE.createApp({
    delimiters: ['{', '}'],
    data() {
      return {
        options: {},
        quantity: 1,
        product: window.ud_product,
      };
    },

    computed: {
      // NOTE: This computed also exists in the collection Vue instance (collection-template.liquid)
      // as computeNumberOfParts(product). Changes here need to be mirrored there.
      numberOfParts() {
        // New system: variant-based (post-import)
        if (this.product.variants?.length > 1) {
          return this.product.variants.length - 1;
        }

        // Old system: sub-product metafield (pre-import, live site)
        if (this.product.part_ids?.length) {
          return this.product.part_ids.length;
        }

        // Floor: solo products have 1 part
        return 1;
      },

      // Resolves difficulty as a normalized integer (1–4) from the injected metafield
      // value (product-template.liquid) or udf_difficulty_ tag fallback.
      // Normalized to integer so colorPlayButton and display logic stay consistent.
      difficulty() {
        const wordMap = {
          beginner: 1,
          intermediate: 2,
          advanced: 3,
          'advanced+': 4,
          'advanced +': 4,
        };

        function normalize(val) {
          if (val == null || val === '') return null;
          const lower = String(val).trim().toLowerCase();
          return wordMap[lower] ?? parseInt(lower, 10) ?? null;
        }

        // product-template.liquid injects difficulty from product.metafields.song.difficulty
        if (this.product.difficulty != null && this.product.difficulty !== '') {
          return normalize(this.product.difficulty);
        }

        // Tag fallback — udf_difficulty_[1-4]
        const tag = this.product.tags?.find((t) =>
          t.startsWith('udf_difficulty_'),
        );
        if (tag) {
          return parseInt(tag.replace('udf_difficulty_', ''), 10) || null;
        }

        return null;
      },

      selectedVariant: function () {
        let variants = this.product.variants;
        let options = [];

        for (const [key, value] of Object.entries(this.options)) {
          options.push(value);
        }

        let variant = variants.find((variant) => {
          let variantOptions = variant.title.split(' / ');

          if (
            variantOptions.length == options.length &&
            variantOptions.every((x) => options.includes(x))
          ) {
            return variant;
          }
        });

        return variant;
      },
      selectedPrice() {
        if (!this.selectedVariant) return 0;
        return this.selectedVariant.price;
      },
    },

    watch: {
      selectedVariant: function () {
        if (
          this.carousel &&
          this.selectedVariant.featured_media !== undefined
        ) {
          this.carousel.slideTo(
            this.product.media
              .map((x) => x.id)
              .indexOf(this.selectedVariant.featured_media.id),
          );
        }

        if (window.history.replaceState) {
          let searchParams = new URLSearchParams(window.location.search);
          searchParams.set('variant', this.selectedVariant.id);

          let newPath =
            window.location.pathname +
            '?' +
            searchParams.toString() +
            window.location.hash;
          window.history.replaceState(null, '', newPath);
        }
      },
    },

    methods: {
      updateQuantity(amount) {
        let quantity = this.quantity + amount;

        this.quantity = quantity <= 0 ? 1 : quantity;
      },

      formatMoney(value) {
        return Shopify.formatMoney(value);
      },

      imageSize(src, size) {
        return src.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
          return '_' + size + match;
        });
      },

      getSongSrc() {
        let handle = this.product.handle.split('-').join('_');
        let url = `https://cdn.shopify.com/s/files/1/0586/2925/9445/files/${handle}.mp3`;
        // this.product['song_src'] = url
        return (this.product['song_src'] = url);
      },

      getSongParts() {
        return new Promise((resolve, reject) => {
          let count = 0;

          this.product.part_ids.forEach((id, index) => {
            fetch(
              `https://shopify.udundi.io/api/product/${id}?myshopify_domain=edukecation`,
            )
              .then((response) => response.json())
              .then((product_data) => {
                fetch(
                  `https://shopify.udundi.io/api/product/${id}/metafield?myshopify_domain=edukecation`,
                )
                  .then((response) => response.json())
                  .then((product_metafields) => {
                    let songMetafields = product_metafields
                      .filter((x) => x.namespace == 'song')
                      .map((x) => ({ [x.key]: x.value }));
                    Object.assign(product_data, ...songMetafields);

                    this.product.parts.push({
                      number: index + 1,
                      ...product_data,
                    });
                    count++;

                    if (count >= this.product.part_ids.length) {
                      this.product.parts.sort((a, b) => a.number - b.number);
                      resolve();
                    }
                  });
              })
              .catch((error) => {
                reject(error);
              });
          });
        });
      },

      addToCart(e) {
        e.preventDefault();

        // If you still want to add legacy parts (optional)
        if (
          this.product.part_ids?.length &&
          document.querySelectorAll('input[name=partSelector]:checked').length
        ) {
          const checkedParts = Array.from(
            document.querySelectorAll('input[name=partSelector]:checked'),
          ).map((input) => input.value);

          checkedParts.forEach((id) => CartJS.addItem(id, 1));
        } else {
          // Use the Vue-selected variant and quantity
          if (!this.selectedVariant) {
            console.warn('No variant selected!');
            return;
          }

          CartJS.addItem(this.selectedVariant.id, this.quantity)
            .then(() => {
              console.log(
                `Added ${this.quantity} of variant ${this.selectedVariant.id} to cart`,
              );
            })
            .catch((err) => {
              console.error('Add to cart failed:', err);
            });
        }
      },

      seek(id, event) {
        // let clickedSong = this.all_products.find(product => product.id == id)
        let clickedSong = this.product;
        let progressBar = this.$refs['progress-' + id];
        let progressParent = this.$refs['progress-parent-' + id];
        let audio = this.$refs['audio-' + id];

        const percent = event.offsetX / progressParent.offsetWidth;
        // console.log('audio current time: ', audio.currentTime)
        audio.currentTime = (percent / 100) * audio.duration * 100;
        clickedSong['width'] = percent;
      },

      initProgressBar(id) {
        let clickedSong = this.product;
        let progressBar = this.$refs['progress-' + id];

        function progressSize(current, overall) {
          return (current / overall) * 100;
        }

        const { currentTime, duration } = this.$refs['audio-' + id];

        clickedSong['width'] = progressSize(currentTime, duration);

        const audio = this.$refs['audio-' + id];

        audio.addEventListener('ended', () => {
          const playBtn = this.$refs['play-' + id];
          const time = this.$refs['duration-' + id];
          playBtn.classList.remove('pause');
          clickedSong['width'] = 0;
          time.innerHTML = '0:00';
        });
      },

      updateTime(id) {
        function parseTime(time) {
          const seconds = String(Math.floor(time % 60 || 0)).padStart('2', '0');
          const minutes = String(Math.floor(time / 60 || 0)).padStart('2', '0');

          return `${minutes}:${seconds}`;
        }

        const { currentTime, duration } = this.$refs['audio-' + id];

        // audio time stamp that user sees
        this.$refs['duration-' + id].innerHTML = `${parseTime(currentTime)}`; // `${parseTime(currentTime)}/${parseTime(duration)}`

        this.initProgressBar(id);
      },

      colorPlayButton() {
        // Uses the difficulty computed which normalizes tag/injected value to an integer
        const diff = this.difficulty;
        if (!diff) return;

        switch (diff) {
          case 1:
            return 'btn-color-green';
          case 2:
            return 'btn-color-orange';
          case 3:
            return 'btn-color-blue';
          case 4:
            return 'btn-color-yellow';
        }
      },

      toggleAudio(id) {
        const media = this.$refs['audio-' + id];
        const playBtn = this.$refs['play-' + id];

        if (media.paused === false) {
          media.pause();
          playBtn.classList.remove('pause');
        } else {
          media.play();
          playBtn.classList.add('pause');
          this.initProgressBar(id);
        }
      },
    },

    created() {
      let searchParams = new URLSearchParams(window.location.search);
      let selectedVariant = this.product.variants.find(
        (x) => x.id == searchParams.get('variant'),
      );

      if (selectedVariant !== undefined) {
        this.product.options.forEach((option, index) => {
          this.options[option.name] = selectedVariant.options[index];
        });
      } else {
        this.product.options.forEach((option, index) => {
          this.options[option.name] = option.values[0];
        });
      }
    },

    mounted() {
      this.carousel = new Swiper(this.$refs.carousel, {
        grabCursor: true,
        loop: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        pagination: {
          el: '.swiper-pagination',
        },

        spaceBetween: 10,
        observer: true,
        observeSlideChildren: true,
        observeParents: true,
        loopedSlides: 5, //looped slides should be the same

        thumbs: {
          swiper: galleryThumbs,
        },
      });

      var galleryThumbs = new Swiper(this.$refs.thumbs, {
        // grabCursor: true,
        spaceBetween: 10,
        slidesPerView: 4,
        // loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      this.getSongSrc();

      // Write resolved computed values back onto the product object so the
      // audio-player snippet can read product.difficulty and product.numberOfParts
      // directly — matching how the collection page sets these via getFilterOptions.
      this.product.difficulty = this.difficulty;
      this.product.numberOfParts = this.numberOfParts;

      if (this.product.type == 'song' && this.product.part_ids) {
        this.product.parts = [];
        /* this.getSongParts().then(() => {
          console.log(this.product.parts);
        }); */
      }

      console.log(this.product);
    },
  }).mount('#udProductView');
});
